import { cn } from "@v1/ui/utils";
import type { ReactElement } from "react";

/** Quiet speech bubble with a pause badge; theme colors, so dark mode works. */
export function ChatPausedIllustration({ className }: { readonly className?: string }): ReactElement {
  return (
    <svg
      viewBox="0 0 160 120"
      fill="none"
      aria-hidden
      className={cn("h-[120px] w-[160px]", className)}
    >
      <circle cx="80" cy="60" r="56" className="fill-action-500/[0.06]" />
      <circle cx="80" cy="60" r="40" className="fill-action-500/[0.06]" />
      <path
        d="M52 38c0-6.627 5.373-12 12-12h32c6.627 0 12 5.373 12 12v20c0 6.627-5.373 12-12 12H72l-11.2 9.6c-1.3 1.11-3.3.19-3.3-1.52V69.2C54.3 67.1 52 63.4 52 58.9V38Z"
        className="fill-background stroke-primary/15"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <circle cx="68" cy="48" r="3.5" className="fill-primary/15" />
      <circle cx="80" cy="48" r="3.5" className="fill-primary/15" />
      <circle cx="92" cy="48" r="3.5" className="fill-primary/15" />
      <circle cx="107" cy="72" r="14" className="fill-action-500" />
      <circle cx="107" cy="72" r="14" className="stroke-background" strokeWidth="3" />
      <rect x="101.5" y="66" width="3.6" height="12" rx="1.8" className="fill-white" />
      <rect x="108.9" y="66" width="3.6" height="12" rx="1.8" className="fill-white" />
    </svg>
  );
}
